module.exports = __webpack_public_path__ + "static/media/attachment.82087c30.svg";